export const commissions = {
  title: 'Bids, Tenders & Commissions',
  sort: {
    label: 'Sort opportunities',
    deadlineAsc: 'Deadline (soonest first)',
    valueDesc: 'Value (highest first)',
    nameAsc: 'Name A–Z',
  },
  actions: {
    addOpportunity: 'Add opportunity',
    confirmDelete: 'Are you sure you want to delete this opportunity?',
  },
  empty: {
    title: 'No bids or commissions yet',
    description: 'Start by adding a bid, tender or commission opportunity that is relevant to OVERHEAR.',
  },
  columns: {
    open: 'Open',
    applied: 'Applied',
    awarded: 'Awarded',
    closed: 'Closed / Not pursued',
  },
  fields: {
    deadline: 'Deadline',
    value: 'Value',
  },
};

